
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import orosz from "../../assets/orosz.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function OroszMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Orosz magyar fordító</title>
                <meta name='description' content="Ingyenes orosz magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Orosz magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/orosz-magyar-fordito" />
            </Helmet>
            <h1>Orosz magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>Az orosz nyelvről</h2>
                    <img src={orosz} alt="Orosz zászló"></img>
                </div>

                <p>Az orosz vagy a Русский язык (Russkiy yazyk) egy keleti szláv nyelv, amelyet több mint 260 millió ember beszél Oroszországban és a volt Szovjetunió más országaiban. A régióban lingua francaként is széles körben használják. Az orosz gazdag irodalmi hagyományairól, tudományos hozzájárulásairól és az Egyesült Nemzetek Szervezete hat hivatalos nyelvének egyikeként ismert státuszáról.</p>

                <p>Az orosz írásrendszer a cirill ábécét használja, amely 33 betűből áll. Tartalmaz olyan ismerős betűket, mint például А, Б, В és így tovább, valamint egyedi karaktereket, például Ё, Ж, Ц és Щ. A cirill betűs írás és olvasás elsajátítása elengedhetetlen része az orosz nyelvtanulásnak.</p>

                <p>Az orosz kiejtés általában fonetikus, ami azt jelenti, hogy a helyesírás és a kiejtés szorosan összefügg. Vannak azonban szabálytalanságok és regionális eltérések a kiejtésben. Az orosznak van egy megkülönböztető tulajdonsága, az úgynevezett "magánhangzó redukció", ahol a hangsúlytalan magánhangzókat általában semleges vagy csökkentett hanggal ejtik.</p>

                <p>Nyelvtana erősen ragozott, a főnévi ragozások, igeragozások és nyelvtani esetek összetett rendszerével. A főnevek, melléknevek és névmások megváltoztatják a végződésüket, hogy olyan nyelvtani funkciókat jelezzenek, mint az alany, a közvetlen tárgy vagy a birtoklás. Az orosz nyelvnek hat esete van: névelő, accusative, genitivus, dativus, instrumentális és prepozíciós.</p>

                <p>Szókincse szláv eredetű, de más nyelvekből származó kölcsönszavakat is tartalmaz, különösen a franciából, a németből és az angolból. Az orosz irodalom gazdag hagyományokkal rendelkezik olyan neves szerzőkkel, mint Lev Tolsztoj, Fjodor Dosztojevszkij és Anton Csehov. Az orosz klasszikus zene, a balett és a vizuális művészetek is jelentős mértékben hozzájárultak a világkultúrához.</p>

                <p>Az orosz kultúra sokszínű, és hagyományok, szokások és történelmi események széles skáláját öleli fel. Az orosz nyelv tanulása betekintést nyújt az ország történelmébe, folklórjába, hagyományaiba és társadalmi normáiba. Ezenkívül elősegíti az orosz társadalom, annak népe és a világról alkotott egyedi nézőpontjának mélyebb megértését.</p>

                <p>Az orosz nyelvtudás számos lehetőséget kínál. Oroszország globális szereplő a politika, az üzleti élet, a tudomány és a technológia területén. Az orosz nyelv ismerete előnyös lehet az e területeken végzett karrierek, valamint a fordítói, nemzetközi kapcsolatok, újságírási és tudományos munkák során.</p>

                <p>Az oroszt széles körben beszélik a volt Szovjetunió más országaiban, így hasznos az utazáshoz és a kommunikációhoz a régióban. Kapuként is szolgál más szláv nyelvek megértéséhez, és szélesebb perspektívát biztosít a szláv kultúrákról.</p>

                <div className="sectionbottom">
                    <Link to="/magyar-orosz-fordito">Magyar orosz fordító</Link>

                    <img src={orosz} alt="orosz zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>

            </section>
        </>

    )
}

export default OroszMagyar;